import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentPickupActionsResponse = {
  canModify: boolean
  canView: boolean
}

export function getEnrollmentPickupActions(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentPickupActions.url, { id }))
    .get<EnrollmentPickupActionsResponse>()
}
